import { render, staticRenderFns } from "./PPostCodePicker.vue?vue&type=template&id=b40a5dba"
import script from "./PPostCodePicker.vue?vue&type=script&lang=js"
export * from "./PPostCodePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports